/** Must match WinIt-backend meta-capi/buildPayload buildEventId(). */
export function buildEventId(eventType, ticketId) {
  const prefix = eventType === 'traffic_submit' ? 'traffic-submit' : 'traffic-converted'
  return `${prefix}:${ticketId}`
}
